import Skeleton from '@mui/material/Skeleton';
import { ListSkeleton } from '../feed/post';

export const ContactSectionSkeleton = () => {
  return (
    <div>
      <Skeleton
        variant="rounded"
        className="!max-w-[625px]"
        width={'100%'}
        height={100}
      />
      <Skeleton
        variant="rounded"
        className="!max-w-[625px]"
        width={'100%'}
        height={100}
      />
      <Skeleton
        variant="rounded"
        className="!max-w-[625px]"
        width={'100%'}
        height={100}
      />
    </div>
  );
};

export const FollowSectionSkeleton = () => {
  return <Skeleton variant="rounded" width={150} height={60} />;
};

export const FeedTabSkeleton = () => {
  return <ListSkeleton />;
};

export const FollowListSwitchTabSkeleton = () => {
  return (
    <div className="flex gap-3 items-center justify-between">
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
    </div>
  );
};

export const ProfileTabSkeleton = () => {
  return (
    <div className="block lg:flex">
      <div className="flex flex-col gap-5">
        <Skeleton
          variant="rounded"
          className="!max-w-[625px]"
          width={'100%'}
          height={150}
        />
        <Skeleton
          variant="rounded"
          className="!max-w-[625px]"
          width={'100%'}
          height={150}
        />
        <Skeleton
          variant="rounded"
          className="!max-w-[625px]"
          width={'100%'}
          height={150}
        />
      </div>
      <div className="hidden lg:block">
        <Skeleton
          variant="rounded"
          className="!max-w-[270px]"
          width={'100%'}
          height={300}
        />
      </div>
    </div>
  );
};

export const ThreeDotToggleModalSkeleton = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 min-h-screen h-screen mx-auto max-w-none sm:max-w-sm w-screen z-40 bg-gray-500 bg-opacity-50 overflow-hidden">
      <div className="pt-5 pb-[100px] absolute bottom-0 left-0 w-full h-auto bg-white overflow-hidden px-5 rounded-t-xl">
        <Skeleton variant="rounded" width={'100%'} height={60} />
        <Skeleton variant="rounded" width={'100%'} height={60} />
      </div>
    </div>
  );
};

export const FollowModalSkeleton = () => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2 items-center justify-between">
        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      </div>
      <Skeleton variant="rounded" width={'100%'} height={150} />
    </div>
  );
};
